import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Google Material Icons",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M5.00016 18.3332C4.54183 18.3332 4.14947 18.17 3.82308 17.8436C3.49669 17.5172 3.3335 17.1248 3.3335 16.6665V3.33317C3.3335 2.87484 3.49669 2.48248 3.82308 2.15609C4.14947 1.8297 4.54183 1.6665 5.00016 1.6665H11.6668L16.6668 6.6665V16.6665C16.6668 17.1248 16.5036 17.5172 16.1772 17.8436C15.8509 18.17 15.4585 18.3332 15.0002 18.3332H5.00016ZM10.8335 7.49984H15.0002L10.8335 3.33317V7.49984Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgFile);
export default ForwardRef;
